import { DBDef_Expression } from '@app/hcs-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_Expression } from './ModuleFE_Expression.js';
import { resolveId } from '@nu-art/thunderstorm-frontend';
import { generateHex } from '@nu-art/ts-common';
import { Manager_Expression } from '../../ui/_managers/Manager_Expression/Manager_Expression.js';
import { ModuleFE_Variable } from '../variable/ModuleFE_Variable.js';
import { ModuleFE_Value } from '../value/ModuleFE_Value.js';
const { WorkHubItem, UtilObject } = createSearchIntegration({
    module: ModuleFE_Expression,
    dbDef: DBDef_Expression,
    tag: ['Exp', 'Expression'],
    modulesToAwait: [ModuleFE_Expression, ModuleFE_Variable, ModuleFE_Value],
    ManagerComponent: Manager_Expression,
});
export const WorkHubItem_Expression = WorkHubItem;
export const UtilObject_Expression = {
    ...UtilObject,
    prepareTab: (item) => {
        const id = resolveId(item) ?? `###NEWITEM###-${generateHex(8)}`;
        return WorkHubItem_Expression.prepareTab(UtilObject.generateTabId(id), UtilObject.renderLabel(item) ?? 'New Item', { itemId: id, editMode: false });
    },
};
//# sourceMappingURL=util-object.js.map